import "core-js/modules/es.array.map.js";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ColorBatch } from 'components';
import { dateFormat, paymentStatusColorMap, paymentStatusName } from 'enums';
import { getCurrencyConfig } from 'utils';
import { list } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var HomeVisitFeePaymentPlan = function HomeVisitFeePaymentPlan(_ref) {
  var _getCurrencyConfig;

  var paymentPlan = _ref.paymentPlan;
  var currency = (_getCurrencyConfig = getCurrencyConfig()) === null || _getCurrencyConfig === void 0 ? void 0 : _getCurrencyConfig.defaultCurrency;
  return ___EmotionJSX("div", {
    css: list
  }, ___EmotionJSX("div", {
    className: "list-group"
  }, ___EmotionJSX("h6", {
    className: "list-title"
  }, "\u041F\u043E\u0433\u0430\u0441\u0438\u0442\u0435\u043B\u0435\u043D \u043F\u043B\u0430\u043D \u0437\u0430 \u0442\u0430\u043A\u0441\u0430 \u0434\u043E\u043C\u0430\u0448\u043D\u043E \u043F\u043E\u0441\u0435\u0449\u0435\u043D\u0438\u0435"), ___EmotionJSX("table", {
    className: "list-table"
  }, ___EmotionJSX("thead", null, ___EmotionJSX("tr", null, ___EmotionJSX("th", null, "\u2116"), ___EmotionJSX("th", null, "\u0414\u0430\u0442\u0430"), ___EmotionJSX("th", null, "\u0421\u0443\u043C\u0430"), ___EmotionJSX("th", null, "\u041F\u043B\u0430\u0442\u0435\u043D\u043E"), ___EmotionJSX("th", null, "\u0421\u0442\u0430\u0442\u0443\u0441"))), ___EmotionJSX("tbody", null, paymentPlan === null || paymentPlan === void 0 ? void 0 : paymentPlan.map(function (el, index) {
    return ___EmotionJSX("tr", {
      key: el === null || el === void 0 ? void 0 : el.id
    }, ___EmotionJSX("td", null, index + 1), ___EmotionJSX("td", null, moment(el === null || el === void 0 ? void 0 : el.date).isValid() ? moment(el === null || el === void 0 ? void 0 : el.date).format(dateFormat) : 'N/A'), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.amount, " ", currency), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.payed, " ", currency), ___EmotionJSX("td", null, ___EmotionJSX(ColorBatch, {
      type: paymentStatusColorMap[el === null || el === void 0 ? void 0 : el.status],
      fontSize: "1rem"
    }, paymentStatusName[el === null || el === void 0 ? void 0 : el.status])));
  })))));
};

HomeVisitFeePaymentPlan.propTypes = {
  paymentPlan: PropTypes.array
};
export default HomeVisitFeePaymentPlan;